export const getCssText = (style) => {
    const styleAttr = document.createElement('span').style;
    Object.keys(style).forEach((key) => {
        const val = style[key];
        styleAttr[key] = isNaN(val) ? val : val + "px";
    });
    return styleAttr.cssText;
};
